import { render } from "./WorkspaceFederationDefinitionAssociationsEditor.vue?vue&type=template&id=ebc84c70&scoped=true&ts=true"
import script from "./WorkspaceFederationDefinitionAssociationsEditor.vue?vue&type=script&lang=ts"
export * from "./WorkspaceFederationDefinitionAssociationsEditor.vue?vue&type=script&lang=ts"

import "./WorkspaceFederationDefinitionAssociationsEditor.vue?vue&type=style&index=0&id=ebc84c70&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebc84c70"]])

export default __exports__